// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"si-z"};